import ajv from '@f/validation/ajv'
import * as OrderEditedSchema from '@f/validation/schema/datalayer/orderManagement'
import { IOrderEdited } from '@f/validation/types/dataLayer'

export const validateOrderManagement = ajv.compile<IOrderEdited>(OrderEditedSchema.OrderEditedSchema)